import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import logoSGR from '../../assets/SGRLock.png';
import logoSwint from '../../assets/swintLogo.svg';
import Loading from '../../components/Loading';
import { useAuth } from '../../contexts/authContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import api from '../../services/api';
import { Container } from '../Login/styles';
import { Content } from './styles';

const ValidateToken: React.FC = () => {
  const { push } = useHistory();
  const { token } = useParams<{ token: string }>();
  const { setAccessDash, setData, setApiVersion } = useAuth();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.pages.validateToken);
  const { tp: tpLogos } = translationPage(tr => tr.components.logos);

  useEffect(() => {
    api
      .get('/validateDashToken', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(data => {
        setAccessDash(true);

        setData(oldValue => {
          return {
            ...oldValue,
            companyId: data.data.companyId,
            companyName: data.data.companyName,
            optin: data.data.optin,
            userName: data.data.user,
            additionalFields: data.data.additionalFields,
            requiresSelfie: data.data.requiresSelfie !== false,
            hasScoreService: data.data.hasScoreService === true,
            hasPfServices: data.data.hasPfServices !== false,
            hasPjServices: data.data.hasPjServices === true,
          };
        });

        setApiVersion(data.data.version);

        api.defaults.headers.common.authorization = `Bearer ${token}`;
      })
      .catch(() => {
        setAccessDash(false);
        push('/');
      });
  }, [token, push, setAccessDash, setApiVersion, setData]);

  return (
    <Container>
      <img src={logoSGR} alt={tpLogos('sgrLoc')} />
      <Content>
        <img src={logoSwint} alt={tpLogos('swint')} />
        <h1>{tp('title')}</h1>
        <Loading withOverlay={false} />
      </Content>
    </Container>
  );
};

export default ValidateToken;
